var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.516,
    height: 18.871,
    viewBox: "0 0 15.516 18.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    transform: "translate(16072.667 -3791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M142.8,38.335h4.718a3.042,3.042,0,0,0,6.081,0h4.718V35.987l-1.048-1.048V31a6.532,6.532,0,0,0-4.3-6.123v-.063a2.411,2.411,0,1,0-4.823,0,.888.888,0,0,0,.042.231A6.481,6.481,0,0,0,144.268,31v3.879L142.8,35.924Zm7.758,1.678a1.789,1.789,0,0,1-1.782-1.678h3.544A1.756,1.756,0,0,1,150.558,40.013Zm0-16.355a1.189,1.189,0,0,1,1.132.9,6.835,6.835,0,0,0-.922-.063,5.6,5.6,0,0,0-1.342.147,1.134,1.134,0,0,1,1.132-.986Zm-6.5,12.9,1.468-1.048V31a5.242,5.242,0,0,1,10.484,0v3.565h-7.549a.629.629,0,1,0,0,1.258h7.926l.671.671v.587h-13Z",
    transform: "translate(-16215.467 3768.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M235.333,136.077a3.308,3.308,0,0,1,1.615-.419.629.629,0,0,0,0-1.258,4.714,4.714,0,0,0-2.244.587,4.572,4.572,0,0,0-2.307,3.963.629.629,0,0,0,1.258,0A3.339,3.339,0,0,1,235.333,136.077Z",
    transform: "translate(-16301.709 3660.794)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ebe0f2e8c7bf429ca4feb36d6934188d.svg";
export { ForwardRef as ReactComponent };